import clsx from 'clsx'
import Image from 'next/image'
import Carousel from '@/atoms/Carousel/Carousel'

/* utils */
import useWindowSize from '@/hooks/useWindowSize'
import { sliceArrayIntoChunks } from '@/utils/functions/utils'

/* styles */
import styles from './_.module.css'

interface Props {
  title: string
  testimonials: Testimonial[]
}

type Testimonial = {
  authorName: string
  authorDesignation: string
  authorImage?: StrapiImageFile
  review: string
}

const MEDIUM_SCREEN_SIZE = 768

function CreatorTestimonial({ title, testimonials }: Props): JSX.Element {
  const { size } = useWindowSize()
  const noOfSlides =
    size.width >= 1024 ? 3 : size.width >= MEDIUM_SCREEN_SIZE ? 2 : 1
  const getSlides = sliceArrayIntoChunks(testimonials, noOfSlides)

  return (
    <section className="container | py-10 md:py-18">
      <h2 className="font-heading text-3xl lg:text-5xl md:text-center font-medium | mb-8 md:mb-11">
        {title}
      </h2>
      <Carousel
        className={clsx(styles.carousel, 'overflow-hidden')}
        slides={getSlides.map((testimonials, index): JSX.Element => {
          return (
            <div key={index} className="flex md:gap-22 lg:gap-28 px-4 md:px-14">
              {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (testimonials as unknown as any[])?.map(
                  (testimonial: Testimonial) => (
                    <div
                      key={testimonial.authorName}
                      className="relative max-w-full md:w-72"
                    >
                      {testimonial.authorImage ? (
                        <div className="w-full h-auto">
                          <Image
                            src={testimonial.authorImage.url}
                            alt={testimonial.authorImage.alternativeText ?? ''}
                            width={testimonial.authorImage.width}
                            height={testimonial.authorImage.height}
                            className="rounded-xl | mb-8 | max-h-72 | object-cover"
                          />
                        </div>
                      ) : null}
                      <div>
                        <div
                          className="font-heading font-medium text-2xl | mb-8 | line-clamp-5"
                          dangerouslySetInnerHTML={{
                            __html: testimonial.review
                          }}
                        />
                        <p className="text-xl font-semibold md:font-medium text-blue-60 | line-clamp-1 pb-3">
                          {testimonial.authorName}
                        </p>
                        <p className="text-lg md:text-base text-gray-70 | line-clamp-3">
                          {testimonial.authorDesignation}
                        </p>
                      </div>
                    </div>
                  )
                )
              }
            </div>
          )
        })}
      />
    </section>
  )
}

export default CreatorTestimonial
